import type { Composer } from 'vue-i18n'

/**
 * Available asset types for ad materials
 */
export enum AssetType {
  SHOPPING_CART = 'SHOPPING_CART',
  CHECKLIST = 'CHECKLIST',
  UNKNOWN = 'UNKNOWN',
  AD = 'AD',
  FLYER_A5 = 'FLYER_A5',
  FLYER = 'FLYER',
  POSTER = 'POSTER',
  BANNER = 'BANNER',
  SOCIAL_IMAGE = 'SOCIAL_IMAGE',
  SOCIAL_STORY = 'SOCIAL_STORY',
  COASTER = 'COASTER',
  POSTCARD_BLANK = 'POSTCARD_BLANK',
  POSTCARD_TEXT = 'POSTCARD_TEXT',
  NEWSPAPER = 'NEWSPAPER',
  GUIDE = 'GUIDE',
  VIDEO = 'VIDEO',
  DOCUMENT = 'DOCUMENT',
}

/**
 * Get the translated label for an asset type
 * @param type - The asset type to get the label for
 * @param t - The i18n translate function from useI18n()
 */
export function getAssetTypeLabel(type: string, t: Composer['t']): string {
  const assetTypeLabels: Record<string, string> = {
    SHOPPING_CART: t('ad-materials.filter.asset-type.options.shopping_cart'),
    CHECKLIST: t('ad-materials.filter.asset-type.options.checklist'),
    UNKNOWN: t('ad-materials.filter.asset-type.options.unknown'),
    AD: t('ad-materials.filter.asset-type.options.ad'),
    FLYER_A5: t('ad-materials.filter.asset-type.options.flyer_a5'),
    FLYER: t('ad-materials.filter.asset-type.options.flyer'),
    POSTER: t('ad-materials.filter.asset-type.options.poster'),
    BANNER: t('ad-materials.filter.asset-type.options.banner'),
    SOCIAL_IMAGE: t('ad-materials.filter.asset-type.options.social_image'),
    SOCIAL_STORY: t('ad-materials.filter.asset-type.options.social_story'),
    COASTER: t('ad-materials.filter.asset-type.options.coaster'),
    POSTCARD_BLANK: t('ad-materials.filter.asset-type.options.postcard_blank'),
    POSTCARD_TEXT: t('ad-materials.filter.asset-type.options.postcard_text'),
    NEWSPAPER: t('ad-materials.filter.asset-type.options.newspaper'),
    GUIDE: t('ad-materials.filter.asset-type.options.guide'),
    VIDEO: t('ad-materials.filter.asset-type.options.video'),
    DOCUMENT: t('ad-materials.filter.asset-type.options.document'),
  }

  return assetTypeLabels[type] || type
}

/**
 * Get all asset types as an array with labels
 * @param t - The i18n translate function from useI18n()
 */
export function getAllAssetTypes(t: Composer['t']): Array<{ value: string; label: string }> {
  return Object.values(AssetType).map((type) => ({
    value: type,
    label: getAssetTypeLabel(type, t),
  }))
}
